import React, { useState } from "react";
import itinerarios from "./itinerariosData";

export default function Itinerarios() {
  const [modal, setModal] = useState(null);

  return (
    <div className="max-w-6xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-center text-teal-800 mb-8">
        Experiencias por Argentina
      </h2>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {itinerarios.map((item) => (
          <div
            key={item.id}
            className="bg-white rounded-xl shadow p-4 flex flex-col justify-between"
          >
            <div>
              <img src={item.image} alt={item.titulo} className="rounded-xl mb-3 h-40 w-full object-cover"/>
              <h3 className="text-xl font-bold text-teal-900">{item.titulo}</h3>
              <p className="text-gray-600 text-sm mt-1">{item.resumen}</p>
            </div>
            <button
              onClick={() => setModal(item)}
              className="mt-4 text-sm font-semibold text-teal-700 underline hover:text-teal-900"
            >
              Ver detalle
            </button>
          </div>
        ))}
      </div>

      {modal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-6 relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setModal(null)}
              className="absolute top-3 right-4 text-gray-500 hover:text-gray-800 text-xl"
            >
              &times;
            </button>

            <h2 className="text-2xl font-bold text-teal-800 mb-2">{modal.titulo}</h2>

            <div className="text-sm text-gray-700 mb-6">{modal.detalle}</div>

            {/* Íconos de descarga al final del modal */}
            <div className="flex gap-4 justify-end mt-4">
              <a
                href={modal.pdf_es}
                download
                className="flex items-center gap-1 text-sm text-blue-700 hover:underline"
              >
                🇪🇸 Español
              </a>
              <a
                href={modal.pdf_en}
                download
                className="flex items-center gap-1 text-sm text-blue-700 hover:underline"
              >
                🇬🇧 English
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
